import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { WorkspaceUserLimitMessageProps } from './WorkspaceUserLimitMessage';

export const LazyWorkspaceUserLimitMessage: FunctionComponent<
  WorkspaceUserLimitMessageProps
> = ({ location, workspaceId }) => {
  const WorkspaceUserLimitMessage = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "workspace-user-limit-message" */ './WorkspaceUserLimitMessage'
      ),
    { namedImport: 'WorkspaceUserLimitMessage', preload: false },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <WorkspaceUserLimitMessage
          location={location}
          workspaceId={workspaceId}
        />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
